module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"seo":{"title":"Current Interest Rates in Germany"}},"de":{"seo":{"title":"Aktuelle Zinssätze in Deutschland"}}}')
  delete Component.options._Ctor
}
